<mat-form-field class="full-width">
  <mat-label >{{libelle}}</mat-label>
      <input
          matInput
          placeholder="Saisissez le {{libelle.toLocaleLowerCase()}}"
          [formControl]="myControl"
          [matAutocomplete]="auto"
          [required]="required"
          (change)="$event.target.value === '' ? deleteIfEmptyOrNotFound(): null">
  <mat-autocomplete #auto="matAutocomplete"  (optionSelected)="intervenantChange($event.option.value)">
    <mat-option *ngFor="let user of listResp" [value]="user"> {{user.nom + ' ' + user.prenom}}</mat-option>
  </mat-autocomplete>
  <mat-error *ngIf="myControl.hasError('required')">
    Le manager est obligatoire.
</mat-error>
</mat-form-field>